export const PAGE_LOAD = 'military-discount.page-load';
export const GET_STARTED_LINK = 'military-discount-start-link';
export const FAQ_EXPEND = 'military-discount-faq';
export const FAQ_LINKS = 'military-discount-faq-links';
export const VIRTUAL_ID_BTN = 'military-discount-virtual-id-btn';
export const RESTART_APP_LINK = 'military-discount-restart-app-link';
